import { IContact } from "@rentiohq/shared-frontend/dist/types/contact.types";

export interface IExtraData {
  contact: IContact;
}

export enum EField {
  DateOfBirth = "dateOfBirth",
  Nationality = "nationality",
  Address = "address",
  IdCardFront = "IdCardFront",
  IdCardBack = "IdCardBack",
}
